import { render, staticRenderFns } from "./zxtjcpcRedispatchModal.vue?vue&type=template&id=4a7d6cca&scoped=true&"
import script from "./zxtjcpcRedispatchModal.vue?vue&type=script&lang=js&"
export * from "./zxtjcpcRedispatchModal.vue?vue&type=script&lang=js&"
import style0 from "./zxtjcpcRedispatchModal.vue?vue&type=style&index=0&id=4a7d6cca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7d6cca",
  null
  
)

export default component.exports